module.exports = __webpack_public_path__ + "img/20_-Hemorrhoid.cb611965.png";